// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import router from './router'
import store from './store'
import './filter'
import './directive'
import 'weui'
import './assets/scss/app.scss'
import FastClick from 'fastclick'
import wejs from 'weui.js'
import components from '@/components'
import MainView from '@/views/main-view'
import PaySelector from '@/logic-components/pay-selector'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import qs from 'qs'
// import VConsole from 'vconsole'
// import bundler from './tools/bundler'

Vue.use(VueAwesomeSwiper)

if (process.env.NODE_ENV === 'testing') {
  /* eslint-disable */
  const VConsole = require('vconsole')
  const initConsole = new VConsole()
  /* eslint-enable */
}
// bundler(router)

window.router = router

Vue.use(components)

Vue.config.errorHandler = function (err, vm) {
  console.log(err)
  console.log(err.message)
  console.log(vm)
}

// 修复FastClick的Bug
// https://segmentfault.com/a/1190000015234652
FastClick.prototype.focus = function (targetElement) {
  targetElement.focus()
}

window.$injectComplate = function () {
  // TODO 监听IOS自带的桥，使用$bridge_queue
  window.$bridge_queue = window.$fe_bridge_queue
}

/* eslint-disable */
if (window.$fe_bridge) {
  // TODO 适配Android 与 IOS bridge 问题，使用$bridge_queue
  window.$bridge_queue = window.$fe_bridge_queue
  $fe_bridge.progress.dismiss()
  if ($fe_bridge.about.device.iOS) {
    // ios设置navbar
    $fe_bridge.navigation.setTitle('生意商城')
    $fe_bridge.navigation.setBackAction('javascript:if(window.router.app.$route.path!=="/" && location.search.length == 0){router.app.$router.back()}else{$fe_bridge.navigation.popViewController()}')
  }
}
/* eslint-enable */

// 保护器，移除无响应状态的loading
setTimeout(() => {
  if (window.$fe_bridge === undefined) return
  window.$fe_bridge.progress.dismiss()
}, 2000)

router.beforeEach((to, from, next) => {
  /* eslint-disable */
  if (window.$fe_bridge !== undefined) {
    if (window.$fe_bridge.about.device.iOS) {
      if (to.path === '/') {
        window.$fe_bridge.navigation.setRightButton('normal', '个人', 'windowGoAboutMe();')
      } else {
        window.$fe_bridge.navigation.removeRightButton()
      }
    }
  }
  // 统计代码
  // _hmt.push(['_trackPageview', pageURL]) 必须是以"/"（斜杠）开头的相对路径
  if (to.path == '/invite') { window._hmt && window._hmt.push(['_trackPageview', '/#' + to.fullPath]) }
  /* eslint-enable */
  next()
})

FastClick.attach(document.body)

Object.defineProperty(Vue.prototype, '$wejs', {
  get () { return wejs }
})

const bus = new Vue()
Object.defineProperty(Vue.prototype, '$bus', {
  get () { return bus }
})

// 关于我们页面跳转
window.windowGoAboutMe = function () {
  window.router.app.$router.push({ path: `${window.router.app.$route.path}aboutMe` })
}

// 条款跳转
window.windowGoProvision = function () {
  window.router.app.$router.push({ path: `${window.router.app.$route.path}provision` })
}

// 邀请有礼
window.windowProvisionPage = function () {
  if (window.$fe_bridge !== undefined) {
    window.$fe_bridge.page.provisionPage()
  }
}

Vue.config.productionTip = false
let queryObj = qs.parse(location.search.replace(/\?|\/$/g, ''))
/* eslint-disable no-new */
new Vue({
  router,
  store,
  components: { MainView, PaySelector },
  created () {
    if ('redirectUrl' in queryObj) {
      this.$router.push({ path: queryObj.redirectUrl })
    }
  },
  mounted () {
    setTimeout(() => {
      if ('tab' in queryObj) {
        this.$bus.$emit('openTab', queryObj.tab) // 打开指定tab
        return
      }
      this.$bus.$emit('openTab') // 打开默认tab
    }, 0)
  }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js